import { Upload } from 'antd';
import styled from 'styled-components';

const { Dragger: antdDragger } = Upload;

// Collapsed impersonation-banner pull tab. Only the urgency-driven colors
// (background/color/border) stay inline at the call site; the fixed positioning
// and box styling live here.
export const ImpersonationBannerTab = styled.button`
  position: fixed;
  top: var(--app-header-top-offset, 0px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;
  border-top: none;
  border-radius: 0 0 8px 8px;
  padding: 2px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  box-shadow: 0 1px 3px rgb(0 0 0 / 15%);
`;

const Dragger = styled(antdDragger)`
  min-height: 100vh;
  border: none !important;
  cursor: inherit !important;

  &.ant-upload-drag-hover {
    filter: ${({ disabled }) => !disabled && 'brightness(0.5)'};
  }

  body.pspdfkit-document-editor-open &.ant-upload-drag-hover {
    filter: unset;
  }
  & .ant-upload.ant-upload-disabled {
    cursor: inherit;
  }
  & .ant-upload {
    padding: 0 !important;
  }
`;

export default Dragger;
